import { useRef, useEffect } from "react";
import { debounce } from "lodash";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { useTheme } from "@cellectenergy/cellect-react-components";

// Components
import { SearchIcon } from "@/components/svg/SearchIcon";
import InputBase from "@mui/material/InputBase";

// Styles
import * as Styled from "./SearchBar.styles";

const SearchBar = () => {
  const { t } = useTranslation("global");
  const placeholder: string = t(`Blog.searchLabel`);
  const { push, query } = useRouter();
  const theme = useTheme();

  const debouncedSearch = useRef(
    debounce(async (criteria?: string) => {
      const q = { ...query, search: criteria };
      if (criteria === "") {
        delete q.search;
      }
      push({ query: q }, undefined, {
        shallow: true,
      });
    }, 300)
  ).current;

  async function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    debouncedSearch(e.target.value);
  }

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <Styled.SearchBar>
      <SearchIcon />
      <InputBase
        defaultValue={query.search || ""}
        sx={{
          width: "100%",
          color: theme.palette.common.corporateColors.primary.midNightBlue,
          input: {
            padding: "11px 1rem 11px 0",
          },
          ...theme.typography["label-large"],
        }}
        onChange={handleChange}
        placeholder={placeholder}
        inputProps={{ "aria-label": "search" }}
      />
    </Styled.SearchBar>
  );
};

export default SearchBar;
